import React from 'react'
import CustomSelect from '../../../components/CustomSelect/CustomSelect'
import DateRangeFilter from '../../../components/DateRangeFilter'
import { today, firstDayOfMonth, lastDayOfMonth, startOfYear } from '../utils/paymentHelpers'
import * as api from '../../../lib/api'

export default function PaymentsFilters({
  filterType,
  setFilterType,
  filterEmployee,
  setFilterEmployee,
  filterPeriodStart,
  setFilterPeriodStart,
  filterPeriodEnd,
  setFilterPeriodEnd,
  isAdmin,
  hideArchive,

  employees,
  hasActiveFilters,
  payoutFrequency = 'bi_monthly',
  settlementCutoverDate = null
}) {
  return (
    <div className="payments-filters">
      <div style={{ maxWidth: 200, minWidth: 160 }}>
        <CustomSelect
          label="Тип"
          value={filterType}
          onChange={setFilterType}
          options={[
            { value: '', label: 'Все типы' },
            { value: 'bonus', label: 'Премия', icon: <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 12 20 22 4 22 4 12"/><rect x="2" y="7" width="20" height="5"/><line x1="12" y1="22" x2="12" y2="7"/><path d="M12 7H7.5a2.5 2.5 0 0 1 0-5C11 2 12 7 12 7z"/><path d="M12 7h4.5a2.5 2.5 0 0 0 0-5C13 2 12 7 12 7z"/></svg> },
            { value: 'fine', label: 'Штраф', icon: <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/><line x1="12" y1="9" x2="12" y2="13"/><line x1="12" y1="17" x2="12.01" y2="17"/></svg> },
            { value: 'salary', label: 'Выплата ЗП', icon: <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="12" y1="1" x2="12" y2="23"/><path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"/></svg> },
            { value: 'deduction', label: 'Удержание WB', icon: <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="6" cy="6" r="3"/><circle cx="6" cy="18" r="3"/><line x1="20" y1="4" x2="8.12" y2="15.88"/><line x1="14.47" y1="14.48" x2="20" y2="20"/><line x1="8.12" y1="8.12" x2="12" y2="12"/></svg> },
          ]}
        />
      </div>
      {isAdmin && (
        <div style={{ maxWidth: 240, minWidth: 180 }}>
          <CustomSelect
            label="Сотрудник"
            value={filterEmployee}
            onChange={setFilterEmployee}
            options={[
              { value: '', label: 'Все сотрудники' },
              ...employees.filter(e => !e.is_legacy).map(emp => ({
                value: emp.id,
                label: emp.name,
                badge: emp.employment_type === 'substitute' ? 'Подменный' : (emp.pay_day != null ? 'Инд.' : undefined),
              })),
              ...(!hideArchive ? employees.filter(e => e.is_legacy).map(emp => ({
                value: emp.id,
                label: emp.name,
                badge: 'Архив',
                group: 'Архивные',
              })) : []),
            ]}
          />
        </div>
      )}
      <div className="payments-date-filter">
        <DateRangeFilter
          startDate={filterPeriodStart}
          endDate={filterPeriodEnd}
          onApply={(s, e) => {
            setFilterPeriodStart(s)
            setFilterPeriodEnd(e)
          }}
          onReset={() => {
            setFilterPeriodStart(startOfYear())
            setFilterPeriodEnd(today())
          }}
          quickPresets={(() => {
            const now = new Date()
            const m = now.getMonth() + 1
            const y = now.getFullYear()
            const pad = (n) => String(n).padStart(2, '0')
            const selectedEmp = filterEmployee ? employees.find(e => e.id === filterEmployee) : null
            const hiredAt = selectedEmp?.hired_at || null
            const effectiveFreq = api.getEffectivePayoutFrequency ? api.getEffectivePayoutFrequency(selectedEmp, { payoutFrequency }) : (selectedEmp?.employment_type === 'substitute' ? 'weekly' : payoutFrequency)
            const periods = api.getSalaryPeriods(hiredAt, y, m, effectiveFreq, selectedEmp?.pay_day, [], settlementCutoverDate)
            
            // Находим текущий период полумесяца
            const todayStr = `${y}-${pad(m)}-${pad(now.getDate())}`
            const currentPeriod = periods.find(p => todayStr >= p.start && todayStr <= p.end) || periods[periods.length - 1]

            // Расчет текущей недели (пн-вс)
            const currentDay = now.getDay()
            const distanceToMonday = currentDay === 0 ? 6 : currentDay - 1
            const monday = new Date(now)
            monday.setDate(now.getDate() - distanceToMonday)
            const sunday = new Date(monday)
            sunday.setDate(monday.getDate() + 6)
            const thisWeekStart = `${monday.getFullYear()}-${pad(monday.getMonth() + 1)}-${pad(monday.getDate())}`
            const thisWeekEnd = `${sunday.getFullYear()}-${pad(sunday.getMonth() + 1)}-${pad(sunday.getDate())}`

            const resultPresets = []
            const seenKeys = new Set()

            // 1. Текущая неделя
            const weekKey = `${thisWeekStart}_${thisWeekEnd}`
            seenKeys.add(weekKey)
            resultPresets.push({ label: 'Текущая неделя', getValue: () => [thisWeekStart, thisWeekEnd] })

            // 2. Расчетный период полумесяца (если отличается от текущей недели)
            if (currentPeriod) {
              const periodKey = `${currentPeriod.start}_${currentPeriod.end}`
              if (!seenKeys.has(periodKey)) {
                seenKeys.add(periodKey)
                resultPresets.push({ label: currentPeriod.label, getValue: () => [currentPeriod.start, currentPeriod.end] })
              }
            }

            // 3. Этот месяц
            const thisMonthStart = firstDayOfMonth()
            const thisMonthEnd = lastDayOfMonth()
            const monthKey = `${thisMonthStart}_${thisMonthEnd}`
            if (!seenKeys.has(monthKey)) {
              seenKeys.add(monthKey)
              resultPresets.push({ label: 'Этот месяц', getValue: () => [thisMonthStart, thisMonthEnd] })
            }

            // 4. Прошлый месяц
            const prevMonthFirst = new Date(now.getFullYear(), now.getMonth() - 1, 1)
            const prevMonthLast = new Date(now.getFullYear(), now.getMonth(), 0)
            const prevMonthStart = `${prevMonthFirst.getFullYear()}-${pad(prevMonthFirst.getMonth() + 1)}-01`
            const prevMonthEnd = `${prevMonthLast.getFullYear()}-${pad(prevMonthLast.getMonth() + 1)}-${pad(prevMonthLast.getDate())}`
            const prevMonthKey = `${prevMonthStart}_${prevMonthEnd}`
            if (!seenKeys.has(prevMonthKey)) {
              seenKeys.add(prevMonthKey)
              resultPresets.push({ label: 'Прошлый мес.', getValue: () => [prevMonthStart, prevMonthEnd] })
            }

            return resultPresets
          })()}
          showQuickButtons
        />
      </div>
      {hasActiveFilters && (
        <button
          className="btn btn-ghost btn-sm payments-reset-filter"
          onClick={() => {
            setFilterType('')
            setFilterEmployee('')
            setFilterPeriodStart(startOfYear())
            setFilterPeriodEnd(today())
          }}
        >
          Сбросить всё
        </button>
      )}

    </div>
  )
}
